import React from 'react';
import { Level } from 'fitbeat.gym-core';
import { IntermediateLevelIcon, BeginnerLevelIcon, ExpertLevelIcon } from '../../ui/components/Icons';
import IntermediateLevelSvg from '../../assets/images/intermediate.svg';
import AdvancedLevelSvg from '../../assets/images/advanced.svg';
import BeginnerLevelSvg from '../../assets/images/beginner.svg';
import Theme from '../../theme';
import { i18n } from '../../utils';
import { defaultScale } from '../../utils/scaling';

const iconWidth = defaultScale(30);
const iconHeight = defaultScale(20);
export const mappedSkillLevelIcons = {
  [Level.Beginner]: (color = Theme.BLACK) =>
    <BeginnerLevelIcon color={color} width={iconWidth} height={iconHeight} />,
  [Level.Basic]: (color = Theme.BLACK) =>
    <IntermediateLevelIcon color={color} width={iconWidth} height={iconHeight} />,
  [Level.Intermediate]: (color = Theme.BLACK) =>
    <ExpertLevelIcon color={color} width={iconWidth} height={iconHeight} />,
}

export const mappedSkillLevelSvgs = {
  [Level.Beginner]: (width, height, fillSecondary = '#231F20') =>
   <BeginnerLevelSvg width={width} height={height} fillSecondary={fillSecondary}/>,
  [Level.Basic]: (width, height, fillSecondary = '#231F20') =>
  <IntermediateLevelSvg width={width} height={height} fillSecondary={fillSecondary}/>,
  [Level.Intermediate]: (width, height, fillSecondary = '#231F20') =>
  <AdvancedLevelSvg width={width} height={height} fillSecondary={fillSecondary} />,
};

export const mappedSkillLevelTitle = {
  [Level.Beginner]: {
    short: i18n.t('bookings:level', { level: 1 }),
    long: i18n.t('bookings:levelBeginner'),
    alt: i18n.t('bookings:beginner'),
  },
  [Level.Basic]: {
    short: i18n.t('bookings:level', { level: 2 }),
    long: i18n.t('bookings:levelIntermediate'),
    alt: i18n.t('bookings:intermediate'),
  },
  [Level.Intermediate]: {
    short: i18n.t('bookings:level', { level: 3 }),
    long: i18n.t('bookings:levelExperienced'),
    alt: i18n.t('bookings:experienced'),
  }
}